<lib-filtered-table
  [tableId]="'delegated-to-me'"
  [tableTitle]="'my_inbox_screen_task_delegation_tab_table_title' | transloco"
  [headerStartTemplate]="headerStartTemplate()"
  [insights]="displayedInsights()"
  [dataSource]="dataSource()"
  [meta]="meta()"
  [columns]="columns()"
  [isLoadingData]="isLoading()"
  [tableFilterTabs]="tableFilterTabs()"
  [(payload)]="payload"
  [tableColumnTemplates]="
    [
      { template: number, identifier: COLUMN_IDENTIFIERS.NUMBER },
      { template: id, identifier: COLUMN_IDENTIFIERS.ID },
      { template: name, identifier: COLUMN_IDENTIFIERS.NAME },
      { template: parent_tasks, identifier: COLUMN_IDENTIFIERS.PARENT_TASKS },
      { template: creation_date, identifier: COLUMN_IDENTIFIERS.CREATION_DATE },
      { template: creator, identifier: COLUMN_IDENTIFIERS.CREATOR },
      { template: sla, identifier: COLUMN_IDENTIFIERS.SLA },
      {
        template: remaining_time,
        identifier: COLUMN_IDENTIFIERS.REMAINING_TIME,
      },
      {
        template: request_subject,
        identifier: COLUMN_IDENTIFIERS.REQUEST_SUBJECT,
      },
      { template: project, identifier: COLUMN_IDENTIFIERS.PROJECT },
      { template: current_step, identifier: COLUMN_IDENTIFIERS.CURRENT_STEP },
      { template: assignees, identifier: COLUMN_IDENTIFIERS.ASSIGNEES },
      { template: status, identifier: COLUMN_IDENTIFIERS.STATUS },
      {
        template: related_requests,
        identifier: COLUMN_IDENTIFIERS.RELATED_REQUESTS,
      },
      { template: action, identifier: COLUMN_IDENTIFIERS.ACTION },
    ]
      | requestSummaryTemplates: mergeRequestColumns() : requestSummary
      | slaSummaryTemplates: mergeRequestColumns() : slaSummary
      | filterTableColByFeatFlag
        : showParentTasksColumn()
        : COLUMN_IDENTIFIERS.PARENT_TASKS
      | filterTableColByFeatFlag
        : showRelatedRequestsColumn()
        : COLUMN_IDENTIFIERS.RELATED_REQUESTS
  "
  [filterOptions]="filterOptions"
  [filterMapping]="filterMapping"
  [searchPlaceholder]="'my_task_screen_search_input_placeholder'"
  [applyOnStreamChanges]="getDelegatedRequests$"
  (streamSucceeds)="handleGetRequestsSuccess($event)"
  (submitExport)="submitExportForm($event)"
  (handleApiCall)="getDelegatedRequests()" />

<ng-template #number let-i="i">
  @let metaData = meta();
  @if (metaData) {
    {{ (metaData.current_page - 1) * metaData.per_page + (i + 1) }}
  }
</ng-template>

<ng-template #id let-row>
  {{ row.flow.request_id }}
</ng-template>

<ng-template #name let-row>
  {{ row.flow.name }}
</ng-template>

<ng-template #creation_date let-row>
  <span dir="ltr">
    {{ row.flow?.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
  </span>
</ng-template>

<ng-template #creator let-row>
  <lib-request-creator [creator]="row.flow.creator" />
</ng-template>

<ng-template #project let-row>
  @if (row.flow?.project?.name) {
    @if (showProjectLink) {
      <a
        [routerLink]="['/projects' | tenantPath, row.flow.project.id]"
        class="flex items-center gap-md cursor-pointer text-neutral-900 hover:!underline hover:text-primary-500">
        <lib-avatar
          [size]="'list'"
          [img]="row.flow.project?.image?.url"
          [fullName]="row.flow?.project?.name"
          borderRadius="rounded-full" />
        <span class="text-xs font-medium">
          {{ row.flow?.project?.name | truncate }}
        </span>
      </a>
    } @else {
      <div class="flex items-center gap-md text-neutral-900">
        <lib-avatar
          [size]="'list'"
          [img]="row.flow.project?.image?.url"
          [fullName]="row.flow?.project?.name"
          borderRadius="rounded-full" />
        <span class="text-xs font-medium">
          {{ row.flow?.project?.name | truncate }}
        </span>
      </div>
    }
  }
</ng-template>
<ng-template #parent_tasks let-row>
  <span>
    {{ row.flow.container_path || '' }}
  </span>
</ng-template>

<ng-template #current_step let-row>
  {{ row.name }}
</ng-template>

<ng-template #sla let-row>
  <div style="width: 90%">
    <div class="flex">
      <span
        libSla
        [clockTemplate]="
          row.state.value === stepStatusEnum.ON_HOLD
            ? onHoldClockTemplate
            : clockTemplate
        "
        [sla]="row.due_date"
        dir="ltr">
        {{ row.due_date | date: 'dd-MMM-yyyy hh:mm a' }}
      </span>
    </div>
  </div>
</ng-template>

<ng-template #remaining_time let-row>
  {{ row.remaining_sla }}
</ng-template>

<ng-template #request_subject let-row>
  <span
    class="min-w-[10.625rem] max-w-[10.625rem] block truncate"
    libTrimTooltip
    placement="top"
    [toolTipClass]="'bg-white p-md rounded-lg shadow-lg tooltip-arrow tooltip-arrow-top w-[20rem] text-balance'"
    [trimLength]="20"
    [fullText]="row.flow.request_subject">
  </span>
</ng-template>

<ng-template #assignees let-row>
  @if (row.current_assignees.length) {
    <lib-user-dropdown-view
      [showAssigneeName]="true"
      [userCount]="row.current_assignees.length"
      [userTableList]="row.current_assignees"
      [userDropdownList]="row.current_assignees"
      [totalDropdownCount]="row.current_assignees.length"
      [assigneeType]="row.assigneeType"
      [headerListLabel]="'dropdown_search_find_assignees_label' | transloco"
      [searchLabel]="'dropdown_search_find_assignees_label' | transloco"
      [searchPlaceholder]="'search_by_name_placeholder' | transloco"
      [noSearchResultLabel]="'no_search_result_label' | transloco"
      [enableLocalSearch]="true"
      [imgDimensions]="{ width: 1.5, height: 1.5 }"
      [containerRef]="'delegated-to-me'" />
  }
</ng-template>

<ng-template #status let-row>
  <lib-badge
    [label]="row.state.label"
    [badgeClass]="
      'px-sm border-none text-xs font-medium text-white ' +
      (row.state.value | stepStatus)
    "></lib-badge>
</ng-template>

<ng-template #related_requests let-row>
  <lib-related-requests-dropdown
    [childFlows]="row.flow.child_flows"
    [viewDetailsRouterLink]="getRelatedRequestViewLink" />
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'delegated-to-me'"
    [menuItems]="getViewActionList(row.id, row.flow.id)"
    (itemClick)="actionListItemClick($event, row)" />
</ng-template>

<ng-template #clockTemplate let-isOverdue>
  <lib-clock-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>

<ng-template #onHoldClockTemplate let-isOverdue>
  <lib-hold-icon
    [iconClass]="
      'size-4 ' + (isOverdue ? 'text-destructive-500' : 'text-neutral-500')
    " />
</ng-template>

<ng-template #requestSummary let-row>
  <lib-request-summary-cell
    [requestId]="row.flow.request_id"
    [workflowType]="row.flow.name"
    [subject]="row.flow.request_subject" />
</ng-template>

<ng-template #slaSummary let-row>
  <lib-sla-summary-cell
    [dueDate]="row.due_date"
    [remaining]="row.remaining_sla"
    [onHold]="row.state.value === stepStatusEnum.ON_HOLD" />
</ng-template>
